import React from "react";

//Components
import NavBar from "./Navbar";
import HomeSection from "./HomeSection";
import ProductsSection from "./ProductsSection";
import ServicesSection from "./ServicesSection";
import AboutUsSection from "./AboutUsSection";
import ContactUsSection from "./ContactUsSection";
import Footer from "./Footer";

function Home() {
  return (
    <div className="home">
      <NavBar />
      <HomeSection />
      <ProductsSection />
      <ServicesSection />
      <AboutUsSection />
      <ContactUsSection />
      <Footer />
    </div>
  );
}

export default Home;
